import React from 'react';
import '../styles/PublicPages.css';
import headerImage from '../assets/images/header.png';

const Contact = () => {
  return (
    <div className="staff-page">
      <div className="auth-container">
        <div className="auth-header">
          <img src={headerImage} alt="HomeCrowd" className="auth-logo" />
        </div>

        <div className="auth-form">
          <div className="contact-content">
            <h1 className="contact-main-title">Contact Us</h1>

            <div className="contact-intro">
              <p className="contact-text">
                We're here to help! Whether you have questions about your account, need technical support,
                or want to share feedback about our platform, our team is ready to assist you.
              </p>
            </div>

            <div className="contact-section">
              <h2 className="contact-section-title">Get in Touch</h2>

              <div className="contact-method">
                <h3 className="contact-method-title">Email Support</h3>
                <p className="contact-text">
                  For general inquiries, account questions, or technical support:
                </p>
                <p className="contact-highlight">
                  <a href="mailto:support@gethomecrowd.com" className="contact-link">
                    support@gethomecrowd.com
                  </a>
                </p>
                <p className="contact-response-time">Response time: Within 24 hours</p>
              </div>

              <div className="contact-method">
                <h3 className="contact-method-title">Business Inquiries</h3>
                <p className="contact-text">
                  For partnership opportunities, merchant onboarding, or business development:
                </p>
                <p className="contact-highlight">
                  <a href="mailto:partnerships@gethomecrowd.com" className="contact-link">
                    partnerships@gethomecrowd.com
                  </a>
                </p>
                <p className="contact-response-time">Response time: Within 48 hours</p>
              </div>

            </div>

            <div className="contact-section">
              <h2 className="contact-section-title">What to Include in Your Message</h2>
              <div className="contact-help-steps">
                <div className="contact-step">
                  <div className="step-number">1)</div>
                  <div className="step-content">
                    <h3 className="contact-step-title">Describe Your Issue</h3>
                    <p className="contact-step-text">
                      Be as specific as possible about what you're experiencing or what you need help with.
                    </p>
                  </div>
                </div>
                <div className="contact-step">
                  <div className="step-number">2)</div>
                  <div className="step-content">
                    <h3 className="contact-step-title">Include Your Account Info</h3>
                    <p className="contact-step-text">
                      Provide your email address associated with your HomeCrowd account (never share passwords).
                    </p>
                  </div>
                </div>
                <div className="contact-step">
                  <div className="step-number">3)</div>
                  <div className="step-content">
                    <h3 className="contact-step-title">Add Screenshots if Helpful</h3>
                    <p className="contact-step-text">
                      If you're experiencing a technical issue, screenshots can help us understand the problem faster.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="contact-section">
              <h2 className="contact-section-title">Frequently Asked Questions</h2>

              <div className="contact-faq">
                <div className="faq-item">
                  <h3 className="faq-question">How do I reset my password?</h3>
                  <p className="faq-answer">
                    Use the "Forgot Password" link on the login screen, or contact support if you continue having issues.
                  </p>
                </div>

                <div className="faq-item">
                  <h3 className="faq-question">Is my payment information secure?</h3>
                  <p className="faq-answer">
                    Yes! We use bank-level encryption and never store your full card details. View our <a href="/privacy-policy/">privacy policy</a> for more details.
                  </p>
                </div>
              </div>
            </div>

            <div className="contact-section">
              <h2 className="contact-section-title">Office Information</h2>
              <div className="office-info">
                <p className="contact-text"><strong>HomeCrowd Inc</strong></p>
                <p className="contact-text">Email: <a href="mailto:support@gethomecrowd.com" className="contact-link">support@gethomecrowd.com</a></p>
                <p className="contact-text">Business Hours: Monday - Friday, 9:00 AM - 5:00 PM MST</p>
              </div>
            </div>

            <div className="contact-cta">
              <h2 className="cta-title">We're Here to Help!</h2>
              <p className="cta-text">
                Don't hesitate to reach out with any questions, concerns, or feedback.
                Your success with HomeCrowd is our top priority.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;